import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useNavigate, useLocation } from "react-router-dom";
import { veifryPan } from "../../api";
import { swlAlert } from "../../../component";



/**
 * ReConfirmPanDetails component asks the user to confirm PAN details before submission.
 * Handles verification, loading state, and navigation based on API response.
 */
const ReConfirmPanDetails = ({ login = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  //   const { userId } = useParams();
  const pandetail = location.state?.uservalue || {};
  const uservalue = location.state?.userId || {};
  const [isLoading, setIsLoading] = useState(false);
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const handleYesClick = () => {
    setIsLoading(true);
    let formData = new FormData()
    formData.append('pan_number', pandetail.pan_number)
    formData.append('name', 'syz')
    formData.append('iirpl_sap_code', uservalue)
    veifryPan(formData).then((data) => {
      if (Number(data?.code) === 0) {
        swlAlert(data)
        navigate(-1);
      } else {
        if (data?.data?.status === 'VALID') {
          navigate(`/${redirectUrl}/pancard-details`, { state: { panDetails: data?.data, userEntered: pandetail, userId: uservalue } });
        } else {
          navigate(`/${redirectUrl}/wrong-pancard-details`, { state: { panNumber: pandetail, response: data?.data, userId: uservalue } });
          // Handle error scenario as needed
        }
      }
    }).catch(error => {
      // Handle API call error
      alert("API call error", error);
    }).finally(() => {
      //setIsLoading(false); // Set loading to false after API call
    });
  };

  return (
    <>

      <div className="container mt-4">

        <div className="row">
          <div className="col-md-6 mt-10 pancard-data">
            <div className="text-center mb-7">
              <img
                width="50%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/reconfirmation-min.png")}
              />
            </div>
          </div>

          <div className="col-md-6 mt-3 pancard-data">
            <div className="mt-3">
              <h1 className="mb-5">Re-Confirm</h1>
              <p>Please make sure you have checked all your details.</p>
              <p>Pan Number :  <span className="text-danger fs-3 fw-semibolder">{pandetail.pan_number ? pandetail.pan_number.toUpperCase() : ''}</span></p>
              <div className="btns cn-btn mt-15 d-flex">
                <button
                  className="btn bgdark-blue text-white"
                  onClick={() => navigate(-1)}
                >
                  No
                </button>
                <button
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: isLoading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: isLoading ? "not-allowed" : "pointer",
                  }}
                  onClick={() => handleYesClick()}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReConfirmPanDetails